import { render, staticRenderFns } from "./TrangChu.vue?vue&type=template&id=9cd231de&"
import script from "./TrangChu.vue?vue&type=script&lang=js&"
export * from "./TrangChu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports